import React from 'react';
import './EventBuilder.css';

const EventBuilder = ({ 
    eventData, 
    onEventDataChange, 
    onAddEventDay, 
    onUpdateEventDay, 
    onRemoveEventDay,
    onAddTimeSlot,
    onUpdateTimeSlot,
    onRemoveTimeSlot,
    onAddTicket,
    onUpdateTicket,
    onRemoveTicket,
    onAddTicketBenefit,
    onUpdateTicketBenefit,
    onRemoveTicketBenefit
}) => {
    return (
        <div className="sales-event-builder">
            <h3>Event Configuration</h3>
            <p className="sales-section-description">Create a comprehensive event with multiple days, time slots, and ticket options</p>
            
            {/* Event Type Selection */}
            <div className="sales-form-group">
                <label>Event Type *</label>
                <div className="sales-event-type-selector">
                    <button 
                        type="button"
                        className={`sales-event-type-btn ${eventData.eventType === 'digital' ? 'active' : ''}`}
                        onClick={() => onEventDataChange('eventType', 'digital')}
                    >
                        💻 Digital Event
                    </button>
                    <button 
                        type="button"
                        className={`sales-event-type-btn ${eventData.eventType === 'in-person' ? 'active' : ''}`}
                        onClick={() => onEventDataChange('eventType', 'in-person')}
                    >
                        📍 In-Person Event
                    </button>
                </div>
            </div>

            {/* Location/Meeting Info */}
            {eventData.eventType === 'digital' && (
                <div className="sales-form-group">
                    <label>Meeting URL *</label>
                    <input
                        type="url"
                        value={eventData.meetingUrl || ''}
                        onChange={(e) => onEventDataChange('meetingUrl', e.target.value)}
                        placeholder="https://zoom.us/j/... or other meeting platform"
                    />
                </div>
            )}

            {eventData.eventType === 'in-person' && (
                <div className="sales-form-group">
                    <label>Event Address *</label>
                    <textarea
                        value={eventData.eventAddress || ''}
                        onChange={(e) => onEventDataChange('eventAddress', e.target.value)}
                        placeholder="Full address including street, city, postal code"
                        rows={3}
                    />
                </div>
            )}

            {/* Event Days */}
            <div className="sales-event-section">
                <h4>Event Schedule</h4>
                {(eventData.eventDays || []).map((day, dayIndex) => (
                    <div key={dayIndex} className="sales-event-day-card">
                        <div className="sales-day-header">
                            <div className="sales-day-title">Day {dayIndex + 1}</div>
                            <button 
                                type="button" 
                                className="sales-module-remove"
                                onClick={() => onRemoveEventDay(dayIndex)}
                                title="Remove day"
                            >
                                ✕
                            </button>
                        </div>
                        
                            <div className="sales-day-content">
                                <div className="sales-form-row">
                                    <div className="sales-form-group">
                                        <label>Date *</label>
                                        <input
                                            type="date"
                                            value={day.date}
                                            onChange={(e) => onUpdateEventDay(dayIndex, 'date', e.target.value)}
                                        />
                                    </div>
                                    <div className="sales-form-group">
                                        <label>Day Title</label>
                                        <input
                                            type="text"
                                            value={day.title}
                                            onChange={(e) => onUpdateEventDay(dayIndex, 'title', e.target.value)}
                                            placeholder="e.g. Opening Day"
                                        />
                                    </div>
                                </div>

                                <div className="sales-form-group">
                                    <label>Day Description</label>
                                    <textarea
                                        value={day.description}
                                        onChange={(e) => onUpdateEventDay(dayIndex, 'description', e.target.value)}
                                        placeholder="What happens on this day? Give attendees an overview..."
                                        rows={3}
                                    />
                                </div>

                            {/* Time Slots */}
                            <div className="sales-time-slots">
                                <label>Time Slots</label>
                                {(day.timeSlots || []).map((slot, slotIndex) => (
                                    <div key={slotIndex} className="sales-time-slot-item">
                                        <div className="sales-slot-header">
                                            <div className="sales-time-inputs">
                                                <div className="sales-time-input-wrapper">
                                                    <label>Start</label>
                                                    <input
                                                        type="time"
                                                        value={slot.startTime}
                                                        onChange={(e) => onUpdateTimeSlot(dayIndex, slotIndex, 'startTime', e.target.value)}
                                                    />
                                                </div>
                                                <span className="sales-time-separator">—</span>
                                                <div className="sales-time-input-wrapper">
                                                    <label>End</label>
                                                    <input
                                                        type="time"
                                                        value={slot.endTime}
                                                        onChange={(e) => onUpdateTimeSlot(dayIndex, slotIndex, 'endTime', e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <button 
                                                type="button" 
                                                className="sales-slot-remove"
                                                onClick={() => onRemoveTimeSlot(dayIndex, slotIndex)}
                                                title="Remove time slot"
                                            >
                                                ✕
                                            </button>
                                        </div>

                                        <div className="sales-slot-content">
                                            <div className="sales-form-group">
                                                <label>Session Title *</label>
                                                <input
                                                    type="text"
                                                    value={slot.title}
                                                    onChange={(e) => onUpdateTimeSlot(dayIndex, slotIndex, 'title', e.target.value)}
                                                    placeholder="e.g. Welcome & Networking"
                                                />
                                            </div>
                                            
                                            <div className="sales-form-group">
                                                <label>Session Description</label>
                                                <textarea
                                                    value={slot.description}
                                                    onChange={(e) => onUpdateTimeSlot(dayIndex, slotIndex, 'description', e.target.value)}
                                                    placeholder="What will happen during this session? Include key topics, speakers, or activities..."
                                                    rows={3}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                <button 
                                    type="button" 
                                    className="sales-add-btn"
                                    onClick={() => onAddTimeSlot(dayIndex)}
                                >
                                    + Add Time Slot
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
                
                <button 
                    type="button" 
                    className="sales-add-btn primary"
                    onClick={onAddEventDay}
                >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                        <line x1="16" y1="2" x2="16" y2="6"/>
                        <line x1="8" y1="2" x2="8" y2="6"/>
                        <line x1="3" y1="10" x2="21" y2="10"/>
                    </svg>
                    Add Event Day
                </button>
            </div>

            {/* Tickets */}
            <div className="sales-event-section">
                <h4>Ticket Types</h4>
                {(eventData.tickets || []).map((ticket, ticketIndex) => (
                    <div key={ticketIndex} className="sales-ticket-card">
                        <div className="sales-ticket-header">
                            <div className="sales-ticket-title">Ticket {ticketIndex + 1}</div>
                            <button 
                                type="button" 
                                className="sales-module-remove"
                                onClick={() => onRemoveTicket(ticketIndex)}
                                title="Remove ticket"
                            >
                                ✕
                            </button>
                        </div>
                        
                        <div className="sales-ticket-content">
                            <div className="sales-form-row">
                                <div className="sales-form-group">
                                    <label>Ticket Name *</label>
                                    <input
                                        type="text"
                                        value={ticket.name}
                                        onChange={(e) => onUpdateTicket(ticketIndex, 'name', e.target.value)}
                                        placeholder="e.g. Early Bird, VIP, Standard"
                                    />
                                </div>
                                <div className="sales-form-group">
                                    <label>Available Tickets</label>
                                    <input
                                        type="number"
                                        value={ticket.availability}
                                        onChange={(e) => onUpdateTicket(ticketIndex, 'availability', e.target.value)}
                                        placeholder="100"
                                        min="1"
                                    />
                                </div>
                            </div>

                            <div className="sales-form-group">
                                <label>Description</label>
                                <textarea
                                    value={ticket.description}
                                    onChange={(e) => onUpdateTicket(ticketIndex, 'description', e.target.value)}
                                    placeholder="What's included with this ticket?"
                                    rows={2}
                                />
                            </div>

                            <div className="sales-ticket-pricing">
                                <h6>Pricing & Payment</h6>
                                
                                <div className="sales-ticket-payment-options">
                                    <div className="sales-payment-method-selector">
                                        <label>Payment Method</label>
                                        <select
                                            value={ticket.paymentType || 'stripe'}
                                            onChange={(e) => onUpdateTicket(ticketIndex, 'paymentType', e.target.value)}
                                        >
                                            <option value="stripe">💳 Stripe Payment</option>
                                            <option value="cash">💵 Cash Payment</option>
                                            <option value="free">🎁 Free Ticket</option>
                                        </select>
                                    </div>

                                    {ticket.paymentType !== 'free' && (
                                        <div className="sales-ticket-price-config">
                                            <label>Ticket Price</label>
                                            <div className="sales-price-input-group">
                                                <input
                                                    type="number"
                                                    value={ticket.price}
                                                    onChange={(e) => onUpdateTicket(ticketIndex, 'price', parseFloat(e.target.value) || 0)}
                                                    placeholder="99"
                                                    min="0"
                                                    step="0.01"
                                                />
                                                <select
                                                    value={ticket.currency || 'EUR'}
                                                    onChange={(e) => onUpdateTicket(ticketIndex, 'currency', e.target.value)}
                                                >
                                                    <option value="EUR">EUR</option>
                                                    <option value="USD">USD</option>
                                                    <option value="GBP">GBP</option>
                                                </select>
                                            </div>
                                        </div>
                                    )}

                                    {ticket.paymentType === 'stripe' && (
                                        <div className="sales-stripe-ticket-config">
                                            <label>Stripe Product ID</label>
                                            <input
                                                type="text"
                                                value={ticket.stripeProductId || ''}
                                                onChange={(e) => onUpdateTicket(ticketIndex, 'stripeProductId', e.target.value)}
                                                placeholder="prod_xxx (auto-generated)"
                                                readOnly
                                            />
                                            <small className="sales-help-text">
                                                Stripe product will be auto-created when you save
                                            </small>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Ticket Benefits */}
                            <div className="sales-ticket-benefits">
                                <label>What's Included</label>
                                {(ticket.benefits || []).map((benefit, benefitIndex) => (
                                    <div key={benefitIndex} className="sales-benefit-input">
                                        <input
                                            type="text"
                                            value={benefit}
                                            onChange={(e) => onUpdateTicketBenefit(ticketIndex, benefitIndex, e.target.value)}
                                            placeholder="e.g. Access to all sessions"
                                        />
                                        <button 
                                            type="button" 
                                            className="sales-remove-btn"
                                            onClick={() => onRemoveTicketBenefit(ticketIndex, benefitIndex)}
                                        >
                                            ✕
                                        </button>
                                    </div>
                                ))}
                                <button 
                                    type="button" 
                                    className="sales-add-btn"
                                    onClick={() => onAddTicketBenefit(ticketIndex)}
                                >
                                    + Add Benefit
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
                
                <button 
                    type="button" 
                    className="sales-add-btn primary"
                    onClick={onAddTicket}
                >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
                        <line x1="8" y1="21" x2="16" y2="21"/>
                        <line x1="12" y1="17" x2="12" y2="21"/>
                    </svg>
                    Add Ticket Type
                </button>
            </div>
        </div>
    );
};

export default EventBuilder;
